/* eslint-disable no-restricted-imports */
import React, {useMemo} from 'react'
import {UIGameActionButton} from '../../../common/UIGameActionButton'
import {T} from '@colonist/ui'
import {useActionButtonCommonErrors} from '../utils'
import {ActionState, TurnState} from '@colonist/game-states'
import {SHIP_MOVE_IMAGE_PATH} from './utils'
import {useGameStore} from '../../../store/GameStoreContext'
import {TranslationObject} from '@colonist/i18n'
import {useUIGameSocketContext} from '../../../contexts/UIGameSocketContext'
import {useCurrentStateValidator} from '../../../store/selectors/useCurrentStateValidator'
import {useMechanicValidatorShipMove} from '../../../store/selectors/useMechanicValidatorShipMove'

export const UIGameActionButtonShipMove = ({
    className,
}: {
    className?: string
}) => {
    const myColor = useGameStore((state) => state.myColor)
    const {sendMoveShip, sendCancelAction, sendClearRoadEdgeHighlight} = useUIGameSocketContext()
    const shipMoveValidator = useMechanicValidatorShipMove()
    const currentState = useGameStore((state) => state.gameState.currentState)
    const currentStateValidator = useCurrentStateValidator()
    const {errorHelperText, hasCommonErrors} = useActionButtonCommonErrors()
    const isSpecialBuildPhase = currentState.turnState == TurnState.SpecialBuildPhase

    const actionStatus = useMemo(() => {
        if(!shipMoveValidator) {
            return {canTakeAction: false}
        }

        return shipMoveValidator.canPlayerMoveShip(myColor)
    }, [shipMoveValidator, myColor])

    const disabled = hasCommonErrors || !actionStatus.canTakeAction || isSpecialBuildPhase
    const helperText: TranslationObject | undefined = errorHelperText || actionStatus.errorMessageIfCantTakeAction
    const actionState = currentStateValidator.getPlayerActionState(myColor)
    const isMovingShip = [ActionState.SelectShipToMove, ActionState.MoveShip].includes(actionState) && !disabled
    const icon = SHIP_MOVE_IMAGE_PATH[myColor]

    const onClick = () => {
        if(disabled) return
        if(isMovingShip) {
            sendClearRoadEdgeHighlight()
            sendCancelAction()
        } else {
            sendMoveShip()
        }
    }

    return <UIGameActionButton
        className={className}
        highlight={isMovingShip}
        disabled={disabled}
        helperText={helperText}
        iconPath={icon}
        centerTextTooltip
        tooltipTitle={<T id='strings:game.tooltips.moveShip'/>}
        onClick={onClick}
    />
}
